import SidebarHeader from '../../components/sidebar/SidebarHeader.jsx';
import {setLocalStorageCurrentIdentity} from '../../utils/localStorage.js';
import {useTranslation} from 'react-i18next';
import translations from '../../../translations/translations.cs-CZ.json';

function retryApplication() {
    window.location.reload();
}

function signOutAfterApplicationFailure() {
    setLocalStorageCurrentIdentity(null);
    window.location.assign('/sign/in');
}

export default function ApplicationFailure({startup = false}) {
    const {t} = useTranslation();

    return (
        <main className="min-h-[100dvh] bg-slate-50 flex items-center justify-center px-4 py-10">
            <section className="w-full max-w-lg rounded-lg border border-slate-200 bg-white p-8 text-center shadow-sm">
                <div className="mb-8 flex justify-center" aria-label="Datixo">
                    <SidebarHeader logoOnly/>
                </div>
                <h1 className="mb-3 text-2xl font-semibold text-slate-900">
                    {startup
                        ? t('application-failure.startup-title', {defaultValue: 'Aplikaci se nepodařilo načíst'})
                        : t('application-failure.title', {defaultValue: 'Něco se pokazilo'})}
                </h1>
                <p className="mb-8 text-slate-600">
                    {startup
                        ? t('application-failure.startup-description', {defaultValue: 'Při načítání aplikace došlo k neočekávané chybě. Zkuste to prosím později.'})
                        : t('application-failure.description', {defaultValue: 'Aplikace narazila na neočekávanou chybu. Zkuste to prosím za chvíli znovu.'})}
                </p>
                <div className="flex flex-col-reverse justify-center gap-3 sm:flex-row">
                    <button
                        className="btn border-slate-200 bg-white text-slate-700 hover:border-slate-300"
                        type="button"
                        onClick={signOutAfterApplicationFailure}
                    >
                        {translations.auth['sign-out']}
                    </button>
                    <button
                        className="btn bg-violet-600 text-white hover:bg-violet-700"
                        type="button"
                        onClick={retryApplication}
                    >
                        {t('application-failure.retry', {defaultValue: 'Zkusit znovu'})}
                    </button>
                </div>
            </section>
        </main>
    );
}
